import React from "react";
import "./Header.scss";
import { isMobile, isIos } from "../../static/helper";
import Shares from "../Shares/Shares";
import Navigation from "../Navigation/Navigation";
import { GA_Event } from "../Analytics/Analytics";

function Header(props) {
  const negishut = () => {
    document.getElementById("INDmenu-btn").click();
  };

  const shareNavigator = () => {
    window.navigator.share({
      title: "שם המשחק - ynet",
      text:
        'מ-FIFA ועד מיינקראפט, מה-Sims ועד מורטל קומבט: הגיע הזמן להכריע אחת ולתמיד – מהו משחק הווידאו הטוב ביותר בכל הזמנים?',
      url: "https://z.ynet.co.il/mshort/content/2020/gamesparade",
    });
    GA_Event(
      "Share_Events",
      "Games Parade",
      "Social - Share Mobile",
      "Site Head"
    );
  };

  return (
    
    <>

      <header className={`header ${props.class}`}>
        <div className="logos">
          <h2 className="title" onClick={() => props.setPageSection("home")}>
            שם המשחק
          </h2>

          <a
            target="_blank"
            href="https://www.ynet.co.il"
            className="logo"
          ></a>
          <div className="seven-nights"></div>
        </div>
        {props.class !== "home" ? (
          <Navigation
            isResultsDisplay={props.isResultsDisplay}
            currentCategoryIndex={props.currentCategoryIndex}
            isResultsDisplay={props.isResultsDisplay}
            categories={props.categories}
            currentCategory={props.currentCategory}
            selectedItems={props.selectedItems}
            setCategory={props.setCategory}
            categoryIndex={props.categoryIndex}
          />
        ) : (
          ""
        )}
        <div className="share-section">
          {isMobile() || isIos() ? (
            <div className="share" onClick={shareNavigator}></div>
          ) : (
            <Shares label="Top Bar" location="Site Head"/>
          )}
          <div className="accessibility" onClick={negishut}></div>
        </div>
      </header>
      {props.class !== "home" ? (
        <div className="navigation-title">
          <h3>בחרו מהרשימה את שלושת המשחקים האהובים עליכם</h3>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Header;
